import { APP_PERMISSIONS } from '@report/permission';
import {
  QuestionnaireReportFilterSection,
  QuestionnaireReportPageHeader,
  QuestionnaireReportExportButton,
  QuestionnaireReportTabs,
} from '@report/questionnaire-report';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QuestionnaireReportPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.QUESTIONNAIRE_REPORT.VIEW]}>
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <QuestionnaireReportPageHeader />
        <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
          <PaperSection
            title='รายงานสรุปผลแบบสอบถามหลังการสอบ'
            endAdornment={<QuestionnaireReportExportButton />}
          >
            <Flex
              sx={(theme) => ({
                p: theme.spacing(6),
                gap: theme.spacing(6),
                flexGrow: 1,
                flexDirection: 'column',
              })}
            >
              <QuestionnaireReportFilterSection />
              <QuestionnaireReportTabs />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
